module.exports = __webpack_public_path__ + "static/md-logo3-d18681b995fc79d6ca819b6ed4519a68.png";